<template>
  <div class="box7">
    <div class="box6-top-box">
      <div class="blockone" ref="block"></div>
      <div class="pageTitle">
        <pageTitle
          title="学习路径一目了然&nbsp;&nbsp;做复合型测试人才"
          text="课程涵盖主流测试框架，覆盖多种测试方式。以项目驱动结合AI辅助，打造复合型测试人才"
          titleColor="#24375C"
          titColor="#86909C"
        />
      </div>
      <div class="info">AI全栈测试+鸿蒙生态实战，培养企业急需的<br/>
智能测试人才</div>

      <div class="subject-content">
        <div class="arrow">
          <img
            src="../../../assets/coursePage/softwareTest/box7/arrow.png"
            alt
          />
        </div>
        <div class="demo-box">
          <div class="demo" v-for="(item, index) in list" :key="index">
            <div class="num">{{ item.num }}</div>
            <div class="title">{{ item.title }}</div>
            <div class="text"><b>掌握核心能力：</b>{{ item.text.replace(/^掌握核心能力：/, '') }}</div>
            <div class="tips"><b>胜任岗位：</b>{{ item.tip.replace(/^胜任岗位：/, '') }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="box6-btm-box">
      <div class="courseContent"><b>课程内容</b><i></i></div>
      <div class="box6-btm">
        <div
          class="subject-box"
          v-for="(item, index) in subject"
          :key="index"
          ref="item"
          :style="{
            backgroundColor:
              cur == index && showAnswer ? '#fff' : 'transparent',
          }"
        >
          <div class="subject" @click="changeCur(index)">
            <div
              class="tag"
              :class="{ tag2: index > 7 }"
              :style="{ color: index > 7 ? '#23C3B6' : '#4080FF' }"
            >
              {{ item.tag }}
            </div>
            <div class="title">{{ item.title }}</div>
            <div
              class="icon"
              :class="{ 'img-rotate': cur == index && showAnswer }"
            >
              <img src="../../../assets/coursePage/ai/box6/icon-down.png" alt />
            </div>
          </div>

          <div
            class="course-content"
            :class="{ 'show-answer': cur == index && showAnswer }"
          >
            <div class="line"></div>

            <!-- <template v-if="item.light && item.light.length > 0">
              <div class="title-icon">
                <img
                  src="../../../assets/coursePage/softwareTest/box7/icon1.png"
                  alt
                />可解决的现实问题
              </div>
              <div class="main-text">
                <p v-for="j in item.light" :key="j">{{ j }}</p>
              </div>
            </template> -->

            <div class="title-icon special-title-icon">
              <img
                src="../../../assets/coursePage/softwareTest/box7/icon1.png"
                alt
              />主要内容
            </div>
            <!-- <div class="main-text ability" v-if="item.ability2">
              <p v-for="k in item.ability2" :key="k"><i></i>{{ k }}</p>
            </div> -->
            <div class="main-content">
              <!-- <h1 class="main-content-title">{{ i.title }}</h1> -->
              <div class="main-content-item" v-for="(i, index2) in item.content"
              :key="index2">
                <!-- <span v-for="(i2, index3) in i.arr" :key="index3">
                  {{ i2 }} <i v-if="index3 != i.arr.length - 1">、</i>
                </span> -->
                {{ i }}
              </div>
            </div>

            <div class="title-icon">
              <img
                src="../../../assets/coursePage/softwareTest/box7/icon2.png"
                alt
              />可掌握的核心能力
            </div>
            <div class="main-text ability">
              <p v-for="k in item.ability" :key="k"><i></i>{{ k }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import pageTitle from "../common/pageTitle.vue";
import scrollBox from "../common/scrollBox.vue";
import check from "../../../utils/check";
export default {
  components: {
    pageTitle,
    scrollBox,
  },
  mounted() {},
  data() {
    return {
      list: [
        {
          title: "AI鸿蒙测试",
          text: "掌握核心能力：抢占鸿蒙生态新风口，掌握纯血鸿蒙应用AI测试核心技术，全覆盖功能/专项/自动化全场景测试",
          tip: "胜任岗位：AI鸿蒙测试工程师",
          num: "L6",
        },
        {
          title: "AI性能测试",
          text: "掌握核心能力：AI加持全流程性能测试，掌握智能压测、瓶颈诊断与性能调优，全面搞定企业级高并发项目的性能保障",
          tip: "胜任岗位：AI性能测试工程师、性能测试开发",
          num: "L5",
        },
        {
          title: "AI接口测试",
          text: "掌握核心能力：AI全链路赋能接口测试，快速搞定接口验证、缺陷定位与自动化提效，轻松适配全行业复杂业务测试需求",
          tip: "胜任岗位：接口测试工程师、API自动化测试工程师",
          num: "L4",
        },
        {
          title: "AI自动化测试",
          text: "掌握核心能力：AI赋能Python全栈自动化测试，掌握Web/APP自动化框架设计与持续集成全流程，实现企业级项目高效测试交付",
          tip: "胜任岗位：自动化测试工程师、测试开发工程师",
          num: "L3",
        },
        {
          title: "AI大模型测试",
          text: "掌握核心能力：吃透AI大模型测试核心技术，掌握大模型评测、微调与落地全流程，成为企业争抢的稀缺大模型测试人才",
          tip: "胜任岗位：数据测试专员、大模型测试工程师",
          num: "L2",
        },
        {
          title: "AI智能体测试",
          text: "掌握核心能力：掌握企业级AI智能体全流程测试体系，搞定智能体功能、安全、多场景合规测试，零基础也能抢占AI新赛道核心高薪岗位",
          tip: "胜任岗位：AI智能体测试工程师、大模型测试专员",
          num: "L1",
        },
      ],
      subject: [
        {
          title: "测试基础与AI工具应用",
          tag: "阶段一",
          content: [
            "· AI测试概念与质量模型",
            "· 测试用例设计方法",
            "· AI工具提效测试设计",
            "· 编写测试用例并执行",
            "· 浏览器开发者工具和Charles抓包辅助测试",
            "· 缺陷并使用缺陷管理工具",
            "· 项目需求分析、测试计划编写与测试报告输出"
          ],
          ability: [
            "能根据Web和App项目功能需求，手工设计出验证软件质量的测试数据",
            "能将设计的测试数据精准取执行，手工验证发现软件问题",
            "能在管理工具中提交和关闭缺陷，手工对缺陷进行闭环管理"
          ],
        },
        {
          title: "AI智能体测试",
          tag: "阶段二",
          content: [
            "· AI测试与传统测试的差异",
            "· 识别与测试大模型幻觉",
            "· 设计提示词测试用例",
            "· 搭建智能体平台并完成功能测试",
            "· 智能体进行安全与伦理测试",
            "· RAG系统专项测试"
          ],
          ability: [
            "AI测试新思维、AI核心概念体系与测试视角",
            "大模型幻觉识别与测试方法",
            "提示词工程——测试工程师的新脚本",
            "智能体初体验与测试思维建立",
            "智能体平台快速入门（Dify/Coze）",
            "智能体核心功能深度掌握（知识库配置、工作流编排、记忆管理）",
            "智能体多维度测试（功能测试、准确性测试、边界场景测试）",
            "对抗性测试：提示词注入/越狱攻击",
            "内容安全与伦理测试",
            "健壮性测试：异常输入/高并发/资源耗尽",
            "RAG专项测试：知识库质量评估、召回率/精确率",
            "测试用例生成智能体搭建实战"
          ],
        },
        {
          title: "AI大模型测试",
          tag: "阶段三",
          content: [
            "· 搭建Python开发环境并编写脚本",
            "· Pandas进行数据清洗与分析",
            "· 机器学习与深度学习基础原理",
            "· PyTorch进行模型训练与评估",
            "· LoRA进行大模型微调",
            "· DeepEval进行大模型评测"
          ],
          ability: [
            "Python基础：环境搭建、变量/数据类型/运算符、流程控制、异常处理、模块导入",
            "核心数据结构：字符串处理、正则表达式、列表/元组/字典/集合、列表推导式、生成器",
            "高级特性：函数定义与参数传递、lambda匿名函数、文件读写、模块与包",
            "面向对象与线程：类与对象、继承与多态、多线程",
            "Pandas数据分析：Series/DataFrame、数据读写、数据查询与切片",
            "数据清洗核心技术：缺失值处理、重复值处理、异常值检测、数据类型转换",
            "机器学习基础：监督/无监督/强化学习、特征工程、数据集划分、评估指标（准确率/精确率/召回率/F1）",
            "深度学习入门：神经网络、激活函数、损失函数、反向传播、过拟合与欠拟合",
            "模型训练与评估：PyTorch、训练流程(fit)、预测评估(predict)、混淆矩阵、模型保存与加载",
            "大模型与迁移学习：预训练模型(BERT/GPT)、迁移学习原理、LoRA微调、PEFT微调",
            "LLaMA-Factory实战：GPU云服务器、模型选择(Qwen/DeepSeek)、LoRA配置、模型训练与导出部署",
            "大模型评测工具DeepEval：大模型评估方法、DeepEval环境安装与核心功能"
          ],
        },
        {
          title: "AI自动化测试",
          tag: "阶段四",
          content: [
            "· Web/APP自动化测试环境",
            "· Selenium/Playwright编写Web自动化脚本",
            "· appium编写APP自动化脚本",
            "· pytest框架管理自动化用例",
            "· Jenkins实现CI/CD回归测试",
            "· AI工具提效自动化脚本编写"
          ],
          ability: [
            "自动化测试介绍：概念、应用场景、分类、环境搭建",
            "Web自动化测试：pytest框架、Selenium API、Playwright API",
            "版本控制：git版本控制、gitee/gitlab/github",
            "CI/CD集成：Jenkins回归测试、定时执行",
            "Web-UI自动化测试框架设计（0-1）",
            "Selenium-Grid分布式执行",
            "APP自动化测试：Appium框架API",
            "APP自动化测试框架设计（0-1）"
          ],
        },
        {
          title: "接口测试",
          tag: "阶段五",
          content: [
            "· 接口及接口测试介绍",
            "· Postman实现接口测试",
            "· Jmeter实现接口测试",
            "· 接口自动化开发",
            "· 接口测试进阶"
          ],
          ability: [
            "接口测试基础、解析接口API文档及AI提效应用",
            "设计接口测试用例及AI提效应用",
            "接口测试工具-apifox及AI提效应用",
            "业务流程接口用例测试及AI提效应用",
            "单接口用例测试及AI提效应用",
            "测试报告及AI提效应用",
            "接口请求发送-requests库及AI提效应用",
            "接口自动化测试框架设计与实现",
            "数据库介绍、使用工具操作数据库",
            "使用SQL操作数据库及AI提效应用"
          ],
        },
        {
          title: "性能测试",
          tag: "阶段六",
          content: [
            "· 性能测试场景（单业务/混合/峰值/稳定性）",
            "· JMeter执行性能测试并生成报告",
            "· Locust执行性能测试并获取指标数据",
            "· Linux命令监控服务器性能",
            "· Docker部署测试环境"
          ],
          ability: [
            "性能测试介绍：概念、性能测试VS功能测试",
            "性能测试场景：单业务场景、混合业务场景、峰值场景、稳定性测试场景、极限容错场景",
            "AI提效应用：场景设计、脚本编写",
            "JMeter工具：单业务/混合/峰值/稳定性/极限容错场景测试",
            "性能测试总结报告",
            "Locust介绍与安装、框架基本使用",
            "Locust实现单业务/混合场景/分布式测试",
            "Linux常用命令、服务器性能监测",
            "Docker部署及AI提效应用"
          ],
        },
        {
          title: "鸿蒙测试",
          tag: "阶段七",
          content: [
            "· 搭建鸿蒙测试环境",
            "· 鸿蒙应用进行功能与专项测试",
            "· 鸿蒙应用进行自动化测试",
            "· 鸿蒙应用进行性能测试",
            "· APP进行专项/性能/稳定性测试",
            "· Charles抓包辅助测试"
          ],
          ability: [
            "鸿蒙介绍、测试环境搭建",
            "鸿蒙功能测试、专项测试、自动化测试",
            "鸿蒙性能测试",
            "APP前置基础、专项测试",
            "APP性能测试、稳定性测试",
            "Charles抓包辅助测试",
            "智慧园区APP项目实战"
          ],
        },
      ],
      cur: 0,
      prevItemHeight: 0,
      showAnswer: true,
    };
  },
  methods: {
    openDetail() {
      if (localStorage.getItem(`detail-${check.getUrlParam("nid")}`)) {
        window.location.href = localStorage.getItem(
          `detail-${check.getUrlParam("nid")}`
        );
      } else {
        this.zixun("查看详细大纲");
      }
    },
    goTop(index) {
      window.scrollTo(
        0,
        this.$refs.item[index].offsetTop -
          this.$refs.block.offsetHeight -
          this.$refs.block.offsetHeight * 0.3 -
          this.prevItemHeight
      );
    },
    changeCur(index) {
      const a = document.querySelector(".show-answer");
      if (a != null && index > this.cur) {
        this.prevItemHeight = a.offsetHeight;
      }
      if (!this.showAnswer || index <= this.cur) {
        this.prevItemHeight = 0;
      }
      if (index == this.cur) {
        this.showAnswer = !this.showAnswer;
      } else {
        this.showAnswer = true;
        this.cur = index;
      }
      this.goTop(index);
    },
    toLink() {
      window.open("https://m.boxuegu.com/");
    },
    zixun(name) {
      zhuge.track("H5_软件测试专题页", {
        咨询按钮名称: name,
      });
      this.clickZiXun()
    },
  },
};
</script>

<style lang="less" scoped>
.pageTitle {
  padding: 0 36px;
}
.box6-top-box {
  width: 100%;
  background: url("../../../assets/coursePage/ai/box6/bg.png") no-repeat;
  background-size: cover;
}
.blockone {
  height: 80px;
}
.info {
  margin: 28px auto;
  padding: 44px 58px;
 
  width: 726px;
 
  background: url("../../../assets/coursePage/softwareTest/box7/info.png")
    no-repeat;
  background-size: 100% 100%;
  box-sizing: border-box;
  text-align: center;
  font-size: 28px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #4e5969;
  line-height: 48px;
  .tit {
    margin-bottom: 4px;
    font-size: 28px;
    text-align: center;
    font-family: PingFangSC-Medium;
    font-weight: 500;
    color: #009ef8;
    line-height: 48px;
  }
}
.subject-content {
  position: relative;
  display: flex;
  justify-content: center;
  padding: 0px 32px 0 86px;
  box-sizing: border-box;

  .tag {
    position: absolute;
    top: -56px;
    left: 32px;
    font-size: 24px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #4b84fa;
    line-height: 44px;
  }
  .arrow {
    width: 18px;
    height: 1722px;
    img {
      width: 100%;
      height: 100%;
    }
  }

  .demo-box {
    margin-left: 26px;
    .demo {
      position: relative;
      margin-bottom: 32px;
      padding: 24px;
      padding-right: 24px;
      width: 572px;
      background: linear-gradient(
        90deg,
        rgba(255, 255, 255, 0.8) 0%,
        rgba(255, 255, 255, 0.2) 100%
      );
      border-radius: 16px;
      box-sizing: border-box;
      font-size: 24px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #86909c;
      line-height: 40px;

      &::after {
        position: absolute;
        top: 32px;
        left: -47px;
        content: "";
        min-width: 24px;
        max-width: 24px;
        height: 24px;
        background: rgb(241, 251, 253);
        border: 5px solid #4b84fa;
        border-radius: 50%;
        box-sizing: border-box;
      }
      .num {
        position: absolute;
        top: 24px;
        left: -98px;
        width: 34px;
        text-align: right;
        font-size: 28px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        color: #4b84fa;
        line-height: 40px;
      }
      .title {
        margin-bottom: 12px;
        font-size: 26px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #4B84FA;
        line-height: 40px;
      }
      .text {
        position: relative;
        padding-left: 20px;
        font-size: 24px;
        color: #4E5969;
        line-height: 36px;
        b{
          color:#083765;
        }
        &::before {
          content: "";
          position: absolute;
          top: 18px;
          left: 0px;
          width: 4px;
          height: 4px;
          background: #4E5969;
          border-radius: 50%;
        }
      }
      .tips {
        position: relative;
        padding-left: 20px;
        font-size: 24px;
        color: #4E5969;
        line-height: 36px;
        margin-top:8px;
        b{
          color:#083765;
          font-weight: 600;
        }
        &::before {
          content: "";
          position: absolute;
          top: 18px;
          left: 0px;
          width: 4px;
          height: 4px;
          background: #4E5969;
          border-radius: 50%;
        }
      }
    }
    .demo:last-child {
      margin-bottom: 8px;
    }
  }
}

.content-img {
  position: relative;
  .fixed {
    position: absolute;
    left: -8px;
    bottom: -19px;
    img {
      width: 148px;
    }
  }
}
.courseContent {
  position: relative;
  text-align: center;
  width: 288px;
  height: 244px;
  line-height: 244px;
  margin: -20px auto -50px;
  background: url("../../../assets/coursePage/softwareTest/box7/course-bg.png")
    no-repeat;
  background-size: 100% 100%;
  background-origin: center;
  b {
    text-align: center;
    font-size: 36px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #24375c;
    line-height: 50px;
    position: relative;
    z-index: 3;
  }
  i {
    width: 152px;
    height: 6px;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    bottom: 110px;
    background: #9cd4ff;
    border-radius: 2px;
    display: block;
  }
}
.tip {
  background: linear-gradient(
    270deg,
    rgba(255, 255, 255, 0) 0%,
    rgba(220, 243, 255, 0.31) 20%,
    rgba(218, 243, 255, 0.95) 49%,
    rgba(216, 242, 255, 0.31) 85%,
    rgba(255, 255, 255, 0) 100%
  );
  border-radius: 68px;

  font-size: 28px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #5381de;
  line-height: 76px;
  text-align: center;
  margin-top: 76px;
}
.box7 {
  padding: 0 0 0;
  box-sizing: border-box;
  width: 100%;
  font-family: PingFangSC, PingFang SC;
  // background: url("../../../assets/coursePage/softwareTest/box7/bg.png")
  //   no-repeat;
  // background-size: cover;
  // background-origin: center top;
  .topImg {
    height: 586px;
    object-fit: contain;
    margin: 78px 0 0px 150px;
  }
  /deep/ .scorll-box {
    margin-top: 30px;
    background: rgba(75, 132, 250, 0.16) !important;
  }
  /deep/ .container .scorll-box .scorll-block {
    background: #4b84fa !important;
  }
  .box6-btm-box {
    padding-bottom: 72px;
    width: 100%;
    background: linear-gradient(180deg, #f8fcff, #f8fcff 78%, #f8fcff);
    .box6-btm {
    }
  }

  .btn {
    margin: 0 auto;
    margin-top: 60px;
    width: 686px;
    height: 96px;
    background-image: linear-gradient(90deg, #3363fc 0%, #9b97ff 100%);
    box-shadow: 0px 0px 20px 0px #e6eef5;
    border-radius: 48px;
    text-align: center;
    font-family: PingFangSC-Semibold;
    font-size: 30px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 36px;
    letter-spacing: 2px;
    color: #ffffff;
    text-shadow: 0px 2px 6px #207dff;
    line-height: 96px;
  }

  .subject-box {
    margin: 0 auto;
    margin-bottom: 16px;
    width: 686px;
    // overflow: hidden;
    border-radius: 16px;
    box-shadow: 0px 12px 32px 0px rgba(94,123,218,0.08);
  }
  .subject {
    display: flex;
    align-items: center;
    position: relative;
    padding: 28px 32px;
    width: 100%;
    height: 96px;
    background: #FFFFFF;
    border-radius: 16px;
    box-sizing: border-box;
    z-index: 5;

    .tag {
      width: 96px;
      height: 40px;
      background: rgba(255,255,255,0.8);
      border-radius: 8px;
      border: 2px solid #E4F0FF;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 24px;
      color: #4080FF;
      line-height: 24px;
    }
    .tag2 {
      color: rgb(35, 195, 182);
    }
    .title {
      margin-left: 24px;
      margin-right: 20px;
      width: 472px;
      font-size: 28px;
      color: #4E5969;
    }

    .icon {
      width: 28px;
      height: 28px;
      transition: 0.5s ease all;
      img {
        width: 100%;
        height: 100%;
      }
    }

    .img-rotate {
      transition: 0.5s ease all;
      transform: rotate(180deg);
    }

    font-size: 28px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #4e5969;
  }

  .course-content {
    position: relative;
    width: 100%;
    box-sizing: border-box;
    background: #fff;
    max-height: 0;
    opacity: 0;
    transition: max-height 0.3s ease;
    overflow: hidden;
    z-index: 3;
    overflow-y: scroll;
    border-radius: 0 0 16px 16px;
    .line {
      margin-bottom: 32px;
      width: 606px;
      height: 1px;
      background: #f2f3f5;
    }
  }

  .show-answer {
    padding: 0px 32px 40px;
    // display: block;
    max-height: 3900px;
    opacity: 1;
    transition: max-height 0.4s ease;
  }

  .title-icon {
    display: flex;
    align-items: center;
    margin: 32px 0 16px;
    height: 44px;
    font-size: 24px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 600;
    color: #1d2129;
    line-height: 24px;

    img {
      margin-right: 12px;
      width: 24px;
      height: 24px;
      background-size: contain;
    }
  }
  .special-title-icon {
    margin-bottom: 24px;
  }
  .main-content {
    margin-left: 36px;
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    .main-content-title {
      font-size: 26px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #1d2129;
      line-height: 44px;
      margin-bottom: 8px;
    }
    .main-content-item {
      margin: 0 24px 12px 0;
      font-size: 24px;
      color: #4E5969;
      line-height: 40px;
      text-align: left;
      span {
        display: inline-block;
        font-size: 24px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #4e5969;
        line-height: 40px;
      }
      i {
        margin-left: -4px;
      }
    }
    .block {
      margin-bottom: 16px;
      margin-right: 16px;
      padding: 8px 20px;

      border-radius: 8px;

      font-size: 24px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #4e5969;
      display: flex;
      align-items: center;

      background: rgba(106, 161, 255, 0.1);
      border-radius: 10px;
    }
  }

  .main-text {
    p {
      font-family: PingFang SC;
      font-size: 24px;
      color: #4E5969;
      line-height: 40px;
      margin-left: 35px;
      i {
        display: none;
        width: 4px;
        height: 4px;
        background: #87d4bd;
        border-radius: 2px;
        margin-right: 16px;
      }
    }
  }
  .ability {
    p {
      position: relative;
      &::before {
        content: "";
        display: block;
        width: 4px;
        height: 4px;
        background: #87D4BD;
        position: absolute;
        left: -22px;
        top: 18px;
        border-radius: 50%;
      }
    }
  }
}
</style>
